import { useMutation } from '@biletiniz/apollo';
import { UPDATE_PASSWORD } from './gql/update-password';

export const useUpdatePassword = () => {
    const [updatePasswordMutation, { error, loading }] = useMutation(
        UPDATE_PASSWORD
    );

    const updatePassword = updatePasswordInfo => {
        return updatePasswordMutation({
            variables: updatePasswordInfo,
        });
    };
    const initialValues = {
        newPassword: '',
        oldPassword: '',
        confirm: '',
    };

    return {
        error: error?.message,
        updatePassword,
        loading,
        initialValues,
    };
};
